module.exports = __webpack_public_path__ + "img/Guizhou-power.39fd54a6.png";